import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=727e4492"
import script from "./Hints.vue?vue&type=script&lang=js"
export * from "./Hints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports